import qrcode from 'qrcode-generator';

/** Module grid of value's QR code (error correction M, smallest version that fits). */
export function qrModules(value: string): boolean[][] {
  const qr = qrcode(0, 'M');
  qr.addData(value);
  qr.make();
  const n = qr.getModuleCount();
  return Array.from({ length: n }, (_, r) => Array.from({ length: n }, (_, c) => qr.isDark(r, c)));
}
